// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-panel {
  --observer-closed-tab-height: 3.5rem;
  background: var(--surface-panel-color);
  border-left: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
}

.report-panel--menu-open {
  z-index: 40000;
}

.report-panel--menu-open .panel-header {
  position: relative;
  z-index: 40001;
}

.dark .report-panel {
  background: #1c2630;
  border-left-color: #374151;
}

.report-panel.collapsed {
  min-width: 40px;
  max-width: 40px;
  padding: 0;
  align-items: center;
  justify-content: center;
}

.dark .report-panel.collapsed {
  background: #1f2937;
}

.panel-header {
  padding: var(--app-sidebar-header-padding, 1.5rem 1.25rem 1rem);
  border-bottom: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dark .panel-header {
  border-bottom-color: #374151;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.panel-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem var(--app-sidebar-content-padding-inline, 1rem);
  min-height: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.panel-content::-webkit-scrollbar {
  display: none;
}

/* Skills and Strategies render .oars-analytics-shell only while their feedback
   is showing; give it the same fixed-header layout and offset as Full Session so
   "In-Session Analytics" sits in one spot and only the cards scroll. */
.panel-content--analytics-live,
.panel-content:has(> .oars-analytics-shell) {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 0;
}

.panel-content--full-session-live,
.panel-content:has(> .oars-analytics-shell) {
  padding-top: 0.65rem;
}

.panel-content--analytics-collapsed {
  flex: 1 1 auto;
  padding-bottom: 0;
}

/* Compact only the ordinary closed analytics tab. The legacy observer-tab
   sizing above is also used by the TS3 layout and must remain independent. */
.panel-content--analytics-tab-collapsed {
  /* Keep occupying the report body's available space so the turn-navigation
     dock does not jump upward when analytics is closed. */
  flex: 1 1 auto;
  height: auto;
  padding: 0.65rem var(--app-sidebar-content-padding-inline, 1rem) 0;
}

.panel-content--analytics-tab-collapsed > .in-session-analytics {
  margin: 0;
}

.panel-content--analytics-tab-collapsed .analytics-header {
  padding: 0;
}

.panel-content--observer-tab-collapsed {
  flex: 0 0 var(--observer-closed-tab-height);
  height: var(--observer-closed-tab-height);
  box-sizing: border-box;
  overflow: hidden;
  padding: 1rem;
}

.panel-content--analytics-collapsed > .in-session-analytics,
.panel-content--analytics-collapsed > .panel-processing,
.panel-content--analytics-collapsed > .panel-post-session-review {
  flex: 0 0 auto;
  width: 100%;
  margin-top: 0;
}

.panel-content--collapsed-under-ts3-only {
  flex: 0 0 auto;
  padding-bottom: 0;
}

.panel-content--collapsed-under-ts3-only > .in-session-analytics,
.panel-content--collapsed-under-ts3-only > .panel-processing,
.panel-content--collapsed-under-ts3-only > .panel-post-session-review {
  margin-bottom: 1rem;
}

.panel-content--collapsed-under-ts3-only .analytics-header {
  padding-bottom: 0.65rem;
}

.panel-content--observer-tab-collapsed.panel-content--collapsed-under-ts3-only {
  padding: 1rem;
}

.panel-content--observer-tab-collapsed.panel-content--collapsed-under-ts3-only .analytics-header {
  padding-bottom: 0;
}

.panel-content--observer-tab-collapsed > .in-session-analytics,
.panel-content--observer-tab-collapsed > .panel-processing,
.panel-content--observer-tab-collapsed > .panel-post-session-review {
  height: 100%;
  margin: 0;
}

.panel-content--observer-tab-collapsed .analytics-header {
  gap: 0;
  height: 100%;
  justify-content: center;
  padding-bottom: 0;
}

.panel-content--observer-tab-collapsed .analytics-header-row {
  align-items: center;
  min-height: 24px;
}

.panel-content--observer-tab-collapsed .analytics-header-copy {
  gap: 0;
}

.panel-content--observer-tab-collapsed .analytics-subtitle {
  display: none;
}

.panel-content--post-session-metrics {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.panel-section {
  padding: 1rem var(--app-sidebar-content-padding-inline, 1rem) 0;
}

.panel-section--fixed {
  flex-shrink: 0;
  border-bottom: 1px solid #e5e7eb;
  background: var(--surface-panel-color);
}

.panel-section--wai {
  padding-top: 0.65rem;
}

.panel-section--wai-tab-collapsed {
  flex: 0 0 2.8rem;
  height: 2.8rem;
  box-sizing: border-box;
  overflow: hidden;
  /* Match the expanded header's top and horizontal position while centering
     the 24px header inside the 2.8rem closed tab. */
  padding: 0.65rem var(--app-sidebar-content-padding-inline, 1rem) 0;
}

.panel-section--wai-tab-collapsed .wai-section,
.panel-section--wai-tab-collapsed .wai-panel__header {
  margin: 0;
}

.panel-section--wai-tab-collapsed .wai-panel__header {
  align-items: center;
}

.panel-section--wai-tab-collapsed .wai-panel__title-row,
.panel-section--wai-tab-collapsed .wai-panel__header-right {
  align-items: center;
}

.panel-section--ts3 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.panel-section--ts3-expanded {
  flex: 0 1 18rem;
  max-height: 18rem;
  overflow: hidden;
}

.report-panel--ts3-flex-layout .panel-section--ts3-expanded {
  flex: 1 1;
  min-height: 10rem;
  max-height: none;
}

.panel-section--ts3-roomy,
.panel-section--ts3-roomiest {
  max-height: none;
}

.panel-section--ts3-expanded .ts3-section {
  flex: 1 1;
  height: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.panel-section--ts3-collapsed {
  flex: 0 0 auto;
}

.panel-section--observer-tab-collapsed {
  flex: 0 0 var(--observer-closed-tab-height);
  height: var(--observer-closed-tab-height);
  box-sizing: border-box;
  overflow: hidden;
  padding: 1rem;
}

.panel-section--observer-tab-collapsed .ts3-section,
.panel-section--observer-tab-collapsed .wai-section {
  height: 100%;
  margin: 0;
}

.panel-section--observer-tab-collapsed .analytics-header,
.panel-section--observer-tab-collapsed .wai-panel__header {
  gap: 0;
  height: 100%;
  margin-bottom: 0;
}

.panel-section--observer-tab-collapsed .analytics-header-row,
.panel-section--observer-tab-collapsed .wai-panel__header {
  align-items: center;
  min-height: 24px;
}

.panel-section--observer-tab-collapsed .analytics-header-copy {
  gap: 0;
}

.dark .panel-section--fixed {
  border-bottom-color: #374151;
  background: #1c2630;
}

.panel-info,
.panel-processing {
  text-align: center;
  padding: 2rem 1rem;
}

.info-text {
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
}

.dark .info-text {
  color: #f9fafb;
}

.info-subtext {
  color: #6e6e80;
  font-size: 0.8rem;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.dark .info-subtext {
  color: #9ca3af;
}

.btc-counsellor-context-panel {
  padding-top: 0.5rem;
}

.btc-counsellor-context-title {
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: normal;
  text-transform: none;
}

.btc-counsellor-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  max-width: 100%;
  padding: 0.35rem 0.6rem;
  border: 1px solid #dbe3ee;
  border-radius: 999px;
  background: linear-gradient(135deg, #f8fafc 0%, #eef4fb 100%);
  color: #1f2937;
}

.btc-counsellor-pill__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.btc-counsellor-pill__value {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1f2937;
}

.btc-counsellor-context-body {
  text-align: left;
  padding-top: 0.35rem;
}

.btc-counsellor-context-body p {
  margin: 0;
}

.dark .btc-counsellor-pill {
  background: linear-gradient(135deg, #253244 0%, #1f2a38 100%);
  border-color: #374151;
  color: #e5e7eb;
}

.dark .btc-counsellor-pill__label {
  color: #9ca3af;
}

.dark .btc-counsellor-pill__value {
  color: #f9fafb;
}

.btc-counsellor-info-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #9ca3af;
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 600;
  font-style: italic;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
}

.btc-counsellor-info-btn:hover {
  border-color: #6b7280;
  color: #6b7280;
  transform: scale(1.1);
}

.dark .btc-counsellor-info-btn {
  border-color: #6b7280;
  color: #6b7280;
}

.dark .btc-counsellor-info-btn:hover {
  border-color: #9ca3af;
  color: #9ca3af;
}

.panel-processing h4 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.panel-processing .analytics-title {
  margin: 0;
  font-size: 0.92rem;
}

.dark .panel-processing h4 {
  color: #f9fafb;
}

.panel-processing p {
  color: #6e6e80;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

.panel-processing--post-session-metrics {
  text-align: left;
  padding: 0;
  display: flex;
  flex: 1 1;
  min-height: 0;
  width: 100%;
}

.dark .panel-processing p {
  color: #9ca3af;
}

/* Sticky Turn Navigator */
.turn-navigator-sticky {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.55rem 1rem;
  background: var(--surface-color);
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  margin-top: 0;
}

.dark .turn-navigator-sticky {
  background: #1c2630;
  border-top-color: rgba(75, 85, 99, 0.4);
}

.turn-navigator-title {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(71, 85, 105, 0.8);
  text-align: center;
}

.dark .turn-navigator-title {
  color: rgba(203, 213, 225, 0.7);
}

.turn-navigator-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.turn-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 6px;
  background: var(--surface-color);
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
}

.turn-nav-btn:hover:not(:disabled) {
  background: rgba(148, 163, 184, 0.15);
  border-color: rgba(148, 163, 184, 0.6);
  color: #334155;
}

.turn-nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dark .turn-nav-btn {
  background: rgba(31, 41, 55, 0.8);
  border-color: rgba(75, 85, 99, 0.5);
  color: #94a3b8;
}

.dark .turn-nav-btn:hover:not(:disabled) {
  background: rgba(55, 65, 81, 0.8);
  border-color: rgba(100, 116, 139, 0.6);
  color: #e2e8f0;
}

.turn-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #475569;
  min-width: 100px;
  justify-content: center;
}

.dark .turn-indicator {
  color: #cbd5e1;
}

.turn-latest-badge {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  background: rgba(34, 197, 94, 0.15);
  color: #16a34a;
}

.dark .turn-latest-badge {
  background: rgba(34, 197, 94, 0.2);
  color: #4ade80;
}

.turn-waiting {
  font-style: italic;
  color: rgba(100, 116, 139, 0.8);
}

.dark .turn-waiting {
  color: rgba(148, 163, 184, 0.7);
}


@media (max-width: 768px) {
  .report-panel {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    height: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .dark .report-panel {
    background: rgba(31, 41, 55, 0.5);
  }

  .report-panel.collapsed {
    min-width: auto;
    max-width: none;
    padding: 0;
  }

  .panel-header {
    padding: 0.75rem 1rem;
  }

  .panel-content {
    padding: 0.75rem 1rem;
  }

  .panel-content--post-session-metrics {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportPanel.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;uEAEuE;AACvE;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;6EAC6E;AAC7E;EACE;0DACwD;EACxD,cAAc;EACd,YAAY;EACZ,kEAAkE;AACpE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB;oDACkD;EAClD,kEAAkE;AACpE;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,SAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;EAChC,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE;IACE,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".report-panel {\n  --observer-closed-tab-height: 3.5rem;\n  background: var(--surface-panel-color);\n  border-left: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.report-panel--menu-open {\n  z-index: 40000;\n}\n\n.report-panel--menu-open .panel-header {\n  position: relative;\n  z-index: 40001;\n}\n\n.dark .report-panel {\n  background: #1c2630;\n  border-left-color: #374151;\n}\n\n.report-panel.collapsed {\n  min-width: 40px;\n  max-width: 40px;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark .report-panel.collapsed {\n  background: #1f2937;\n}\n\n.panel-header {\n  padding: var(--app-sidebar-header-padding, 1.5rem 1.25rem 1rem);\n  border-bottom: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.dark .panel-header {\n  border-bottom-color: #374151;\n}\n\n.panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.panel-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem var(--app-sidebar-content-padding-inline, 1rem);\n  min-height: 0;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.panel-content::-webkit-scrollbar {\n  display: none;\n}\n\n/* Skills and Strategies render .oars-analytics-shell only while their feedback\n   is showing; give it the same fixed-header layout and offset as Full Session so\n   \"In-Session Analytics\" sits in one spot and only the cards scroll. */\n.panel-content--analytics-live,\n.panel-content:has(> .oars-analytics-shell) {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.panel-content--full-session-live,\n.panel-content:has(> .oars-analytics-shell) {\n  padding-top: 0.65rem;\n}\n\n.panel-content--analytics-collapsed {\n  flex: 1 1 auto;\n  padding-bottom: 0;\n}\n\n/* Compact only the ordinary closed analytics tab. The legacy observer-tab\n   sizing above is also used by the TS3 layout and must remain independent. */\n.panel-content--analytics-tab-collapsed {\n  /* Keep occupying the report body's available space so the turn-navigation\n     dock does not jump upward when analytics is closed. */\n  flex: 1 1 auto;\n  height: auto;\n  padding: 0.65rem var(--app-sidebar-content-padding-inline, 1rem) 0;\n}\n\n.panel-content--analytics-tab-collapsed > .in-session-analytics {\n  margin: 0;\n}\n\n.panel-content--analytics-tab-collapsed .analytics-header {\n  padding: 0;\n}\n\n.panel-content--observer-tab-collapsed {\n  flex: 0 0 var(--observer-closed-tab-height);\n  height: var(--observer-closed-tab-height);\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 1rem;\n}\n\n.panel-content--analytics-collapsed > .in-session-analytics,\n.panel-content--analytics-collapsed > .panel-processing,\n.panel-content--analytics-collapsed > .panel-post-session-review {\n  flex: 0 0 auto;\n  width: 100%;\n  margin-top: 0;\n}\n\n.panel-content--collapsed-under-ts3-only {\n  flex: 0 0 auto;\n  padding-bottom: 0;\n}\n\n.panel-content--collapsed-under-ts3-only > .in-session-analytics,\n.panel-content--collapsed-under-ts3-only > .panel-processing,\n.panel-content--collapsed-under-ts3-only > .panel-post-session-review {\n  margin-bottom: 1rem;\n}\n\n.panel-content--collapsed-under-ts3-only .analytics-header {\n  padding-bottom: 0.65rem;\n}\n\n.panel-content--observer-tab-collapsed.panel-content--collapsed-under-ts3-only {\n  padding: 1rem;\n}\n\n.panel-content--observer-tab-collapsed.panel-content--collapsed-under-ts3-only .analytics-header {\n  padding-bottom: 0;\n}\n\n.panel-content--observer-tab-collapsed > .in-session-analytics,\n.panel-content--observer-tab-collapsed > .panel-processing,\n.panel-content--observer-tab-collapsed > .panel-post-session-review {\n  height: 100%;\n  margin: 0;\n}\n\n.panel-content--observer-tab-collapsed .analytics-header {\n  gap: 0;\n  height: 100%;\n  justify-content: center;\n  padding-bottom: 0;\n}\n\n.panel-content--observer-tab-collapsed .analytics-header-row {\n  align-items: center;\n  min-height: 24px;\n}\n\n.panel-content--observer-tab-collapsed .analytics-header-copy {\n  gap: 0;\n}\n\n.panel-content--observer-tab-collapsed .analytics-subtitle {\n  display: none;\n}\n\n.panel-content--post-session-metrics {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n}\n\n.panel-section {\n  padding: 1rem var(--app-sidebar-content-padding-inline, 1rem) 0;\n}\n\n.panel-section--fixed {\n  flex-shrink: 0;\n  border-bottom: 1px solid #e5e7eb;\n  background: var(--surface-panel-color);\n}\n\n.panel-section--wai {\n  padding-top: 0.65rem;\n}\n\n.panel-section--wai-tab-collapsed {\n  flex: 0 0 2.8rem;\n  height: 2.8rem;\n  box-sizing: border-box;\n  overflow: hidden;\n  /* Match the expanded header's top and horizontal position while centering\n     the 24px header inside the 2.8rem closed tab. */\n  padding: 0.65rem var(--app-sidebar-content-padding-inline, 1rem) 0;\n}\n\n.panel-section--wai-tab-collapsed .wai-section,\n.panel-section--wai-tab-collapsed .wai-panel__header {\n  margin: 0;\n}\n\n.panel-section--wai-tab-collapsed .wai-panel__header {\n  align-items: center;\n}\n\n.panel-section--wai-tab-collapsed .wai-panel__title-row,\n.panel-section--wai-tab-collapsed .wai-panel__header-right {\n  align-items: center;\n}\n\n.panel-section--ts3 {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.panel-section--ts3-expanded {\n  flex: 0 1 18rem;\n  max-height: 18rem;\n  overflow: hidden;\n}\n\n.report-panel--ts3-flex-layout .panel-section--ts3-expanded {\n  flex: 1 1 0;\n  min-height: 10rem;\n  max-height: none;\n}\n\n.panel-section--ts3-roomy,\n.panel-section--ts3-roomiest {\n  max-height: none;\n}\n\n.panel-section--ts3-expanded .ts3-section {\n  flex: 1;\n  height: 100%;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n\n.panel-section--ts3-collapsed {\n  flex: 0 0 auto;\n}\n\n.panel-section--observer-tab-collapsed {\n  flex: 0 0 var(--observer-closed-tab-height);\n  height: var(--observer-closed-tab-height);\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 1rem;\n}\n\n.panel-section--observer-tab-collapsed .ts3-section,\n.panel-section--observer-tab-collapsed .wai-section {\n  height: 100%;\n  margin: 0;\n}\n\n.panel-section--observer-tab-collapsed .analytics-header,\n.panel-section--observer-tab-collapsed .wai-panel__header {\n  gap: 0;\n  height: 100%;\n  margin-bottom: 0;\n}\n\n.panel-section--observer-tab-collapsed .analytics-header-row,\n.panel-section--observer-tab-collapsed .wai-panel__header {\n  align-items: center;\n  min-height: 24px;\n}\n\n.panel-section--observer-tab-collapsed .analytics-header-copy {\n  gap: 0;\n}\n\n.dark .panel-section--fixed {\n  border-bottom-color: #374151;\n  background: #1c2630;\n}\n\n.panel-info,\n.panel-processing {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n\n.info-text {\n  color: #2c3e50;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.dark .info-text {\n  color: #f9fafb;\n}\n\n.info-subtext {\n  color: #6e6e80;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  transition: color 0.3s ease;\n}\n\n.dark .info-subtext {\n  color: #9ca3af;\n}\n\n.btc-counsellor-context-panel {\n  padding-top: 0.5rem;\n}\n\n.btc-counsellor-context-title {\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: normal;\n  text-transform: none;\n}\n\n.btc-counsellor-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  max-width: 100%;\n  padding: 0.35rem 0.6rem;\n  border: 1px solid #dbe3ee;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #f8fafc 0%, #eef4fb 100%);\n  color: #1f2937;\n}\n\n.btc-counsellor-pill__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.btc-counsellor-pill__value {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.btc-counsellor-context-body {\n  text-align: left;\n  padding-top: 0.35rem;\n}\n\n.btc-counsellor-context-body p {\n  margin: 0;\n}\n\n.dark .btc-counsellor-pill {\n  background: linear-gradient(135deg, #253244 0%, #1f2a38 100%);\n  border-color: #374151;\n  color: #e5e7eb;\n}\n\n.dark .btc-counsellor-pill__label {\n  color: #9ca3af;\n}\n\n.dark .btc-counsellor-pill__value {\n  color: #f9fafb;\n}\n\n.btc-counsellor-info-btn {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid #9ca3af;\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-style: italic;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.btc-counsellor-info-btn:hover {\n  border-color: #6b7280;\n  color: #6b7280;\n  transform: scale(1.1);\n}\n\n.dark .btc-counsellor-info-btn {\n  border-color: #6b7280;\n  color: #6b7280;\n}\n\n.dark .btc-counsellor-info-btn:hover {\n  border-color: #9ca3af;\n  color: #9ca3af;\n}\n\n.panel-processing h4 {\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n  transition: color 0.3s ease;\n}\n\n.panel-processing .analytics-title {\n  margin: 0;\n  font-size: 0.92rem;\n}\n\n.dark .panel-processing h4 {\n  color: #f9fafb;\n}\n\n.panel-processing p {\n  color: #6e6e80;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n  transition: color 0.3s ease;\n}\n\n.panel-processing--post-session-metrics {\n  text-align: left;\n  padding: 0;\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.dark .panel-processing p {\n  color: #9ca3af;\n}\n\n/* Sticky Turn Navigator */\n.turn-navigator-sticky {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  padding: 0.55rem 1rem;\n  background: var(--surface-color);\n  border-top: 1px solid rgba(148, 163, 184, 0.25);\n  margin-top: 0;\n}\n\n.dark .turn-navigator-sticky {\n  background: #1c2630;\n  border-top-color: rgba(75, 85, 99, 0.4);\n}\n\n.turn-navigator-title {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(71, 85, 105, 0.8);\n  text-align: center;\n}\n\n.dark .turn-navigator-title {\n  color: rgba(203, 213, 225, 0.7);\n}\n\n.turn-navigator-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.turn-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 6px;\n  background: var(--surface-color);\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.turn-nav-btn:hover:not(:disabled) {\n  background: rgba(148, 163, 184, 0.15);\n  border-color: rgba(148, 163, 184, 0.6);\n  color: #334155;\n}\n\n.turn-nav-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.dark .turn-nav-btn {\n  background: rgba(31, 41, 55, 0.8);\n  border-color: rgba(75, 85, 99, 0.5);\n  color: #94a3b8;\n}\n\n.dark .turn-nav-btn:hover:not(:disabled) {\n  background: rgba(55, 65, 81, 0.8);\n  border-color: rgba(100, 116, 139, 0.6);\n  color: #e2e8f0;\n}\n\n.turn-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #475569;\n  min-width: 100px;\n  justify-content: center;\n}\n\n.dark .turn-indicator {\n  color: #cbd5e1;\n}\n\n.turn-latest-badge {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n  background: rgba(34, 197, 94, 0.15);\n  color: #16a34a;\n}\n\n.dark .turn-latest-badge {\n  background: rgba(34, 197, 94, 0.2);\n  color: #4ade80;\n}\n\n.turn-waiting {\n  font-style: italic;\n  color: rgba(100, 116, 139, 0.8);\n}\n\n.dark .turn-waiting {\n  color: rgba(148, 163, 184, 0.7);\n}\n\n\n@media (max-width: 768px) {\n  .report-panel {\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: 12px;\n    height: auto;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .dark .report-panel {\n    background: rgba(31, 41, 55, 0.5);\n  }\n\n  .report-panel.collapsed {\n    min-width: auto;\n    max-width: none;\n    padding: 0;\n  }\n\n  .panel-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .panel-content {\n    padding: 0.75rem 1rem;\n  }\n\n  .panel-content--post-session-metrics {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
